import React from "react";
import PropTypes from "prop-types";
import get from "lodash/get";
//import pure from "recompose/pure";
import FalseIcon from "@material-ui/icons/Clear";
import TrueIcon from "@material-ui/icons/Done";
import Typography from "@material-ui/core/Typography";
import HelpOutlineIcon from '@material-ui/icons/HelpOutline';
import ReportProblemOutlinedIcon from '@material-ui/icons/ReportProblemOutlined';
import ReportOffOutlinedIcon from '@material-ui/icons/ReportOffOutlined';
import TollOutlinedIcon from '@material-ui/icons/TollOutlined';

//import sanitizeRestProps from "ra-ui-materialui/lib/field/sanitizeRestProps";

export const BoolNumField = ({ className, source, record = {}, ...rest }) => {
  //if (get(record, source) === '0' || get(record, source) === 'N' || get(record, source) === null) {
  if (get(record, source) === '0' || get(record, source) === 'N' ) {
    return (
      <Typography
        component="span"
        body1="body1"
        className={className}
        style={{ display: 'inline-flex', flexDirection: 'column', alignItems: 'center', verticalAlign: 'middle' }}
      >
        <FalseIcon />
        <span style={{ marginTop: -3, fontSize: 10, fontWeight: 600, lineHeight: 1, whiteSpace: 'nowrap'}}>Not Ready</span>
      </Typography>
    );
  }

  if (get(record, source) === '1' || get(record, source) === 'Y') {
    return (
      <Typography
        component="span"
        body1="body1"
        className={className}
        style={{ display: 'inline-flex', flexDirection: 'column', alignItems: 'center', verticalAlign: 'middle' }}
      >
        <TrueIcon   style={{color:'green'}}/>
        <span style={{ marginTop: -3, fontSize: 10, fontWeight: 600, color: 'green', lineHeight: 1, whiteSpace: 'nowrap'}}>Ready</span>
      </Typography>
    );
  }

  if (get(record, source) === 'Q') {
    return (
      <Typography
        component="span"
        body1="body1"
        className={className}
        style={{ display: 'inline-flex', flexDirection: 'column', alignItems: 'center', verticalAlign: 'middle' }}
      >
        <HelpOutlineIcon  style={{color:'navy'}}/>
        <span style={{ marginTop: -3, fontSize: 10, fontWeight: 600, color: 'navy', lineHeight: 1, whiteSpace: 'nowrap'}}>Quarantine</span>
      </Typography>
    );
  }

  if (get(record, source) === 'R') {
    return (
      <Typography
        component="span"
        body1="body1"
        className={className}
        style={{ display: 'inline-flex', flexDirection: 'column', alignItems: 'center', verticalAlign: 'middle' }}
      >
        <ReportOffOutlinedIcon style={{color:'red'}}/>
        <span style={{ marginTop: -3, fontSize: 10, fontWeight: 600, color: 'red', lineHeight: 1, whiteSpace: 'nowrap'}}>Rejected</span>
      </Typography>
    );
  }

  if (get(record, source) === 'E') {
    return (
      <Typography
        component="span"
        body1="body1"
        className={className}
        style={{ display: 'inline-flex', flexDirection: 'column', alignItems: 'center', verticalAlign: 'middle' }}
      >
        <ReportProblemOutlinedIcon  style={{color:'red'}}/>
        <span style={{ marginTop: -3, fontSize: 10, fontWeight: 600, color: 'red', lineHeight: 1, whiteSpace: 'nowrap'}}>Research</span>
      </Typography>
    );
  }

  if (get(record, source) === 'O') {
    return (
      <Typography
        component="span"
        body1="body1"
        className={className}
        style={{ display: 'inline-flex', flexDirection: 'column', alignItems: 'center', verticalAlign: 'middle' }}
      >
        <TollOutlinedIcon style={{color:'orange'}} />
        <span style={{ marginTop: -3, fontSize: 10, fontWeight: 600, color: 'orange', lineHeight: 1, whiteSpace: 'nowrap'}}>Orphan</span>
      </Typography>
    );
  }

  return (
    <Typography
      component="span"
      body1="body1"
      className={className}
     
    />
  );
};

BoolNumField.propTypes = {
  addLabel: PropTypes.bool,
  basePath: PropTypes.string,
  className: PropTypes.string,
  cellClassName: PropTypes.string,
  headerClassName: PropTypes.string,
  label: PropTypes.string,
  record: PropTypes.object,
  sortBy: PropTypes.string,
  source: PropTypes.string.isRequired,
};

//const PureBoolNumField = pure(BoolNumField);
const PureBoolNumField = React.memo(BoolNumField);

PureBoolNumField.defaultProps = {
  addLabel: true,
};

export default PureBoolNumField;